/**
 * CinematicProgress
 * Sinematik yükleme animasyonu
 */

import React from 'react';

export default function CinematicProgress({ percent, message, icon }) {
  // SVG circle için hesaplama
  const radius = 52;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percent / 100) * circumference;
  
  return (
    <div className="oracle-progress-container">
      {/* Progress Ring */}
      <div className="oracle-progress-ring">
        <svg width="120" height="120" viewBox="0 0 120 120">
          <circle 
            className="oracle-progress-ring-bg"
            cx="60" 
            cy="60" 
            r={radius}
          />
          <circle 
            className="oracle-progress-ring-fill"
            cx="60" 
            cy="60" 
            r={radius}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
          />
        </svg>
        <div className="oracle-progress-percent">{percent}%</div>
      </div>
      
      {/* Icon with pulse animation */}
      <div className="oracle-progress-icon">{icon}</div>
      
      {/* Message */}
      <div className="oracle-progress-message">{message}</div>
      <div className="oracle-progress-sub">Lütfen bekleyin...</div>
    </div>
  );
}
